import React from "react"
import "antd/lib/tabs/style/index.css"
import "antd/lib/button/style/index.css"
import "antd/lib/input/style/index.css"
import "./style.css"
import '../../store/reducers'
import {
	Outlet
}from "react-router-dom"

const HelpSection = (props) => {
	return (<>
		<Outlet />
	</>)
}
export default HelpSection
